import fetch from "auth/FetchInterceptor";

export const PromotionService = {};

PromotionService.get = async ({
  page,
  pageSize,
  sort,
  searchText,
  state = null,
}) => {
  let apiUrl = "/v1/promotion?page=" + page + "&per_page=" + pageSize;
  if (sort === "ascend") apiUrl += "&order_by=%2Did";
  else if (sort === "descend") apiUrl += "&order_by=%2Bid";
  if (searchText) apiUrl += "&product=" + searchText;
  if (state) {
    apiUrl += "&state=" + state;
  }
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

PromotionService.getById = async (id) => {
  const apiUrl = `/v1/promotion/${id}`;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

PromotionService.createPromotion = async (data) => {
  const apiUrl = `/v1/promotion`;
  return fetch({
    url: apiUrl,
    method: "post",
    data: data,
  });
};

PromotionService.updatePromotion = async (data) => {
  const apiUrl = `/v1/promotion/${data.id}`;
  return fetch({
    url: apiUrl,
    method: "put",
    data: data,
  });
};

PromotionService.deletePromotion = async (id) => {
  const apiUrl = `/v1/promotion/${id}`;
  return fetch({
    url: apiUrl,
    method: "delete",
  });
};

export default PromotionService;
